/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LicensingInfoWebApp } from './LicensingInfoWebApp';
import {
    LicensingInfoWebAppFromJSON,
    LicensingInfoWebAppFromJSONTyped,
    LicensingInfoWebAppToJSON,
    LicensingInfoWebAppToJSONTyped,
} from './LicensingInfoWebApp';

/**
 * 
 * @export
 * @interface LicensingInfo
 */
export interface LicensingInfo {
    /**
     * 
     * @type {LicensingInfoWebApp}
     * @memberof LicensingInfo
     */
    web_app: LicensingInfoWebApp;
    /**
     * 
     * @type {LicensingInfoWebApp}
     * @memberof LicensingInfo
     */
    mobile_app: LicensingInfoWebApp;
}

/**
 * Check if a given object implements the LicensingInfo interface.
 */
export function instanceOfLicensingInfo(value: object): value is LicensingInfo {
    if (!('web_app' in value) || value['web_app'] === undefined) return false;
    if (!('mobile_app' in value) || value['mobile_app'] === undefined) return false;
    return true;
}

export function LicensingInfoFromJSON(json: any): LicensingInfo {
    return LicensingInfoFromJSONTyped(json, false);
}

export function LicensingInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LicensingInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'web_app': LicensingInfoWebAppFromJSON(json['web_app']),
        'mobile_app': LicensingInfoWebAppFromJSON(json['mobile_app']),
    };
}

export function LicensingInfoToJSON(json: any): LicensingInfo {
    return LicensingInfoToJSONTyped(json, false);
}

export function LicensingInfoToJSONTyped(value?: LicensingInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'web_app': LicensingInfoWebAppToJSON(value['web_app']),
        'mobile_app': LicensingInfoWebAppToJSON(value['mobile_app']),
    };
}

